import { qportalApi } from './qportal-api';
const GetAllAssignmentReason = () => {
    return qportalApi.get(`AssignmentReason/GetAllAssignmentReason`);
};
const GetAssignmentReasonByClientTaskNumber = (ClientId) => {
    return qportalApi.get(`AssignmentReason/GetAssignmentReasonByClientTaskNumber/${ClientId}`);
};
const CreateAssignmentReason = (payload) => {
    return qportalApi.post(`AssignmentReason/CreateAssignmentReason`, payload);
};
const UpdateAssignmentReason = (payload) => {
    return qportalApi.put(`AssignmentReason/UpdateAssignmentReason`, payload);
};
const UpdateAssignmentReasonStatus = (id, payload) => {
    return qportalApi.patch(`AssignmentReason/UpdateAssignmentReasonStatus/${id}`, payload);
};
const DeleteAssignmentReason = (id) => {
    return qportalApi.delete(`AssignmentReason/DeleteAssignmentReason/${id}`);
};
const AssignmentReasonApi = {
    GetAllAssignmentReason,
    GetAssignmentReasonByClientTaskNumber,
    CreateAssignmentReason,
    UpdateAssignmentReason,
    UpdateAssignmentReasonStatus,
    DeleteAssignmentReason
};
export default AssignmentReasonApi;
